/* eslint-disable no-case-declarations */
import {pageData, transMediaList, request} from "@/utils/tool";
import {get} from 'lodash';
// move createPlayer to playerUtil.js or keep it here as per your project structure
export function createPlayer({ container, minWidth, customFontList = [], stageEditable = true }) {
  console.log("创建一个player!", minWidth);
  return new window.AliyunTimelinePlayer({
    container: container,
    licenseConfig: {
      rootDomain: 'yunshiyouke.com.cn',
      licenseKey: "zPtL9R8wGPumTmq2C434ab2bc0b5341ea8f7703afef6793a8",
    },
    aspectRatio: '9:16',
    customFontList: customFontList,
    mode: 'component',
    getMediaInfo: async (mediaId, mediaType, mediaOri) => {
      console.log(">>>", mediaId, mediaType, mediaOri);
      switch (mediaOri) {
        case "mediaId":
          return mediaId;
        case "mediaURL":
          return mediaId;
          // case "public":
          // break;
        default:
          var body;
          console.log("查询mediaId:", mediaId);
          switch (mediaType) {
            case "video":
            case "audio":
              console.log("查询mediaId:", mediaId);
              body = await fetch(
                  "/api/v1/space/media/info/play?media_id=" + mediaId,
                  {
                    headers: {
                      // eslint-disable-next-line no-undef
                      Aid: process.env.REACT_APP_AID,
                    },
                  }
              ).then((res) => res.json());
              console.log("返回body => ", body);
              return body["data"]["play_info_list"][0]["play_url"];
            default:
              console.log("查询mediaId:", mediaId);
              body = await fetch(
                  "/api/v1/space/media/info?media_id=" + mediaId,
                  {
                    headers: {
                      // eslint-disable-next-line no-undef
                      Aid: process.env.REACT_APP_AID,
                    },
                  }
              ).then((res) => res.json());
              console.log("返回body => ", body);
              return body["data"]["file_info_list"][0]["file_basic_info"][
                  "file_url"
                  ];
          }
      }
    },
    // 获取在getEditingProjectMaterials不存在，但在timeline中存在的素材信息
    getTimelineMaterials: async (params) => {
      const jobs = [];
      console.log('测试数据1111')
      params.forEach((item) => {
        if (item.mediaIdType === "mediaURL") {
          if (item.mediaId.includes("ice-pub")) {
            jobs.push({
              Action: "GetPublicMediaInfo",
              params: { InputURL: item.mediaId },
              item,
            });
          } else {
            jobs.push({
              Action: "GetMediaInfo",
              params: { InputURL: item.mediaId },
              item,
            });
          }
        } else if (item.mediaId.indexOf("public") >= 0) {
          jobs.push({
            Action: "GetPublicMediaInfo",
            params: { MediaId: item.mediaId },
            item,
          });
        } else {
          jobs.push({
            Action: "GetMediaInfo",
            params: { MediaId: item.mediaId },
            item,
          });
        }
      });
      const jobPage = pageData(jobs, 5);
      let results = [];
      const extraLibs = [];
      for (let i = 0; i < jobPage.pageCount; i++) {
        const items = jobPage.getData(i + 1);
        const promises = items.map(async (item) => {
          try {
            // const res = await request(item.Action, item.params);
            // return get(res, "data.MediaInfo");
          } catch (ex) {
            // 外链地址兜底逻辑
            extraLibs.push({
              mediaId: item.item.mediaId,
              mediaIdType: item.item.mediaIdType,
              mediaType: item.item.mediaType,
              [`${item.item.mediaType}`]: {
                title: `${item.item.mediaType}_${item.item.mediaId}`, //标题，视频标题
                duration: undefined, // 需要填写真实的视频或音频时长
                coverUrl:
                    item.item.mediaType === "image"
                        ? item.item.mediaId
                        : undefined, ///封面图，图片时必填
              },
            });
          }
        });
        // eslint-disable-next-line no-await-in-loop
        const data = await Promise.all(promises);
        results = results.concat(data.filter((item) => item !== undefined));
      }

      const mediaLibs = transMediaList(results);

      return [...mediaLibs, ...extraLibs];
    },
    minWidth: minWidth,
    stageEditable: stageEditable,
  });
}
